import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
    return (
        <footer className="force-to-bottom">
          <span className="align-bottom">&copy; 2021 Ting-Yi Liu @Ada Developers Academy</span>
        </footer>
    );
}
    

export default Footer;